import React from "react";
import { Spinner, Text, makeStyles, tokens } from "@fluentui/react-components";

const useLoadingStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    gap: tokens.spacingVerticalL,
    backgroundColor: tokens.colorNeutralBackground1,
  },
  text: {
    fontSize: tokens.fontSizeBase400,
    color: tokens.colorNeutralForeground2,
    fontWeight: tokens.fontWeightRegular,
  },
});

/**
 * Reusable Loading component with FluentUI Spinner
 * @param {Object} props
 * @param {string} props.message - Optional loading message (default: "Loading...")
 * @param {string} props.size - Spinner size: "tiny" | "extra-small" | "small" | "medium" | "large" | "extra-large" (default: "large")
 * @param {string} props.label - Optional accessibility label for the spinner
 */
const Loading = ({ message = "Loading...", size = "large", label = "Loading content" }) => {
  const styles = useLoadingStyles();

  return (
    <div className={styles.container}>
      <Spinner size={size} label={label} appearance="primary" />
      {message && <Text className={styles.text}>{message}</Text>}
    </div>
  );
};

export default Loading;
